// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__20lmv","description":"PatientConsentPreview_description__35-g7"};